import { openDB, type IDBPDatabase } from 'idb'

export const DOCUMENT_SESSION_DB_NAME = 'fusegrid_v2_document_session'
export const DOCUMENT_SESSION_DB_VERSION = 2

export const DOCUMENT_SESSION_CHECKPOINTS_STORE = 'document_session_checkpoints'
export const DOCUMENT_SESSION_REPLICAS_STORE = 'document_session_replicas'
export const DOCUMENT_SESSION_PENDING_UPDATES_STORE = 'document_session_pending_updates'

let dbPromise: Promise<IDBPDatabase> | null = null

export const openDocumentSessionDb = (): Promise<IDBPDatabase> => {
  if (!dbPromise) {
    dbPromise = openDB(DOCUMENT_SESSION_DB_NAME, DOCUMENT_SESSION_DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(DOCUMENT_SESSION_CHECKPOINTS_STORE)) {
          const store = db.createObjectStore(DOCUMENT_SESSION_CHECKPOINTS_STORE, { keyPath: 'workbook_id' })
          store.createIndex('by_updated_at', 'updated_at_ms')
        }
        if (!db.objectStoreNames.contains(DOCUMENT_SESSION_REPLICAS_STORE)) {
          const store = db.createObjectStore(DOCUMENT_SESSION_REPLICAS_STORE, { keyPath: 'workbook_id' })
          store.createIndex('by_updated_at', 'updated_at_ms')
        }
        if (!db.objectStoreNames.contains(DOCUMENT_SESSION_PENDING_UPDATES_STORE)) {
          const store = db.createObjectStore(DOCUMENT_SESSION_PENDING_UPDATES_STORE, { keyPath: 'storage_key' })
          store.createIndex('by_workbook_id', 'workbook_id')
          store.createIndex('by_updated_at', 'updated_at_ms')
        }
      },
    })
  }
  return dbPromise
}

export const resetDocumentSessionDbForTests = async (): Promise<void> => {
  const db = dbPromise ? await dbPromise : null
  db?.close()
  dbPromise = null
  if (typeof indexedDB === 'undefined') return
  await new Promise<void>((resolve, reject) => {
    const request = indexedDB.deleteDatabase(DOCUMENT_SESSION_DB_NAME)
    request.onsuccess = () => resolve()
    request.onerror = () => reject(request.error)
    request.onblocked = () => resolve()
  })
}
